import PBService, {PBServiceProps} from "@irati/utils/services"
import env from "@irati/utils/env"
import {DEVELOPMENT, STAGING, LOCAL} from "@irati/utils/constants/environment"
import client from "@irati/utils/services/apollo"
import {
  ClassicCard,
  changeUser,
  getCachedContentCards,
  initialize,
  logCardClick,
  logCardImpressions,
  openSession,
  requestContentCardsRefresh,
  requestImmediateDataFlush,
  subscribeToSdkAuthenticationFailures,
  setSdkAuthenticationSignature
} from "./sdk"
import brazeToken, {brazeTokenKey} from "./mutations/brazeToken"
import {getBrazeApiKey, sdkEndpoint} from "../utils/env"

class BrazeService extends PBService {
  constructor(props: PBServiceProps) {
    super(props)

    initialize(getBrazeApiKey(), {
      baseUrl: sdkEndpoint,
      doNotLoadFontAwesome: true,
      enableLogging: [STAGING, DEVELOPMENT, LOCAL].indexOf(env.ENVIRONMENT_NAME) > -1,
      enableSdkAuthentication: true
    })
    openSession()
  }

  async setUserId(userId: string) {
    const jwtToken = await this.getBrazeJWT()
    changeUser(userId, jwtToken)

    subscribeToSdkAuthenticationFailures(async() => {
      const newJWT = await this.getBrazeJWT()
      setSdkAuthenticationSignature(newJWT)
    })
  }

  getContentCards(): ClassicCard[] {
    requestContentCardsRefresh()
    return getCachedContentCards().cards as ClassicCard[]
  }

  markCardAsClicked(card: ClassicCard) {
    logCardClick(card, true)
    requestImmediateDataFlush()
  }

  markCardsAsSeen(cards: ClassicCard[]) {
    logCardImpressions(cards, true)
    requestImmediateDataFlush()
  }

  async getBrazeJWT(): Promise<string> {
    const {data} = await client.mutate({
      mutation: brazeToken
    })
    return data[brazeTokenKey]
  }
}

const brazeService = new BrazeService({errorHandlers: []})

export default brazeService
